import React, { useState, useEffect } from "react";
// import { Link } from "gatsby"

import Layout from "../components/layout"
// import Image from "../components/image"
import SEO from "../components/seo"
import Img from "gatsby-image"
import { useStaticQuery, graphql } from "gatsby";
import moment from "moment";



const PropsalPage = () => {
  const [engagedYears, setEngagedYears] = useState(0);
  const [engagedMonths, setEngagedMonths] = useState(0);
  const [engagedDays, setEngagedDays] = useState(0);


  useEffect(() => {
    // Calculate years engaged
    const engagedStartDate = moment([2020, 9, 8]);
    const now = moment();
    const numSeconds = now.diff(engagedStartDate, "seconds", true);
    const numYears = numSeconds / 31556952;
    const numMonths = (numYears * 12) % 12;
    const numDays = (numMonths * 30) % 30;
    setEngagedYears(Math.floor(numYears));
    setEngagedMonths(Math.floor(numMonths));
    setEngagedDays(Math.floor(numDays));
  });


  const coupleData = useStaticQuery(graphql`
    query {
      allFile (
        filter: {
          relativeDirectory: { eq: "proposal" }
        }
      ) {
        edges {
          node {
            name
            childImageSharp {
              fluid(maxHeight: 1000) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
    }
  `)

  const images = coupleData.allFile.edges.sort((a, b) => {
    if (a.node.name > b.node.name) {
      return 1;
    } else if (a.node.name < b.node.name) {
      return -1;
    } else {
      return 0;
    }
  });

  const firstColumn = [];
  const secondColumn = [];

  images.forEach((edge, index) => {
    const node = edge.node;

    const imgHtml = (
      <div className="columnImgContainer">
        <Img fluid={node.childImageSharp.fluid} />
      </div>
   );

    if ((typeof window !== 'undefined' && window.innerWidth < 768) || index % 2 === 0) {
      firstColumn.push(imgHtml);
    } else {
      secondColumn.push(imgHtml);
    }
  });

  return (
    <Layout
      maxWidth={1240}
      padding="0px 5px"
      title="She said yes! ❤️"
    >
      <SEO title="Jen & Zain's Proposal" />
      <div className="paragraphContainer">
        I proposed to Jen on October 8, 2020 at Bluffer's Park 🏔
      </div>
      <div className="paragraphContainer">
        Now we've been engaged &nbsp;for {engagedYears} years, {engagedMonths} months, and {engagedDays} days now! 🎉
      </div>
      <div className="paragraphContainer">
        Thank you to Shannon and Evan for hiding in tall grass for 1 hour to help us capture the moment 😂 &nbsp;❤️
        <br/>
        <span className="sideNote">
          <a href="https://www.instagram.com/shaerobbs/" target="_blank" rel="noopener noreferrer">Click here for Shannon's Instagram</a>
        </span>
      </div>
      <div className="flexContainer">
        <div className="column">
          {firstColumn}
        </div>
        <div className="column">
          {secondColumn}
        </div>
      </div>
      <div className="videoContainer">
        <iframe
          width="560"
          height="349"
          src="https://www.youtube.com/embed/vzJgFFL5Q78"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        >
        </iframe>
      </div>
    </Layout>
  );
}

export default PropsalPage
